import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const LinksRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.single ? 'center' : 'space-between')};
  margin: 10px 0 15px;
`;

const LinkButton = styled('button')`
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.orange};
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 12px;
  padding: 0;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

const IdntyExistingUserLinks = ({
  editEmailLabel, isForgotPasswordSubmitting, onEditEmail, onForgotPassword, showForgotPassword,
}) => (
  <LinksRow single={!showForgotPassword}>
    <LinkButton onClick={onEditEmail} type='button'>{editEmailLabel}</LinkButton>
    {showForgotPassword && (
      <LinkButton disabled={isForgotPasswordSubmitting} onClick={onForgotPassword} type='button'>
        {isForgotPasswordSubmitting ? 'Sending...' : 'Forgot password?'}
      </LinkButton>
    )}
  </LinksRow>
);

IdntyExistingUserLinks.propTypes = {
  editEmailLabel: PropTypes.string,
  isForgotPasswordSubmitting: PropTypes.bool,
  onEditEmail: PropTypes.func.isRequired,
  onForgotPassword: PropTypes.func,
  showForgotPassword: PropTypes.bool,
};

IdntyExistingUserLinks.defaultProps = {
  editEmailLabel: 'Not you?',
  isForgotPasswordSubmitting: false,
  onForgotPassword: null,
  showForgotPassword: true,
};

export default IdntyExistingUserLinks;
